import type { PipelineGridRow } from "src/pages/PipelinesIndexPage/components/PipelinesTable/PipelinesTable.types.ts";
import type { PipelineV2 } from "src/queries/pipelines/pipeline.types";
import { secondsToHumanReadable } from "@utils/time";

export const transformPipelineApiData = (p: PipelineV2): PipelineGridRow => ({
  ...p,
  starred: false,
  name: p.app_name,
  runs: {
    totalRuns: {
      count: p.runs_count,
      statuses: p.status_agg,
    },
    recentRuns: p.app_runs || [],
  },
  last_run: p.app_runs?.at(-1)?.last_run,
  sla: {
    linkFilter: "SLA+Time",
    value: p.sla_value_avg,
    has_incident: p.has_sla_alert,
    humanReadableValue:
      p.sla_value_avg === null
        ? null
        : secondsToHumanReadable({
            seconds: p.sla_value_avg as number,
            round: true,
          }),
  },
  duration: {
    linkFilter: "Execution+Time",
    value: p.duration_value_avg,
    has_incident: p.has_duration_alert,
    humanReadableValue:
      p.duration_value_avg === null
        ? null
        : secondsToHumanReadable({
            seconds: p.duration_value_avg as number,
            round: true,
          }),
  },
  freshness: {
    count: p.freshness_alerts_sum,
    linkFilter: `metric_group_type="freshness"`,
  },
  volume: {
    count: p.volume_alerts_sum,
    linkFilter: `metric_group_type="volume"`,
  },
  distribution: {
    count: p.distribution_alerts_sum,
    linkFilter: `metric_group_type="distribution"`,
  },
  others: {
    count: p.other_incidents_count,
  },
  total: {
    count: p.total_incidents_count,
  },
});

export const transformApiData = (pipelines: PipelineV2[]): PipelineGridRow[] =>
  pipelines?.map((p) => transformPipelineApiData(p));

export const imposeStarredPipelinesOverData = (
  data: PipelineGridRow[] | undefined,
  starredPipelines: Record<string, boolean>,
  env: string
): PipelineGridRow[] | undefined => {
  if (
    starredPipelines !== null &&
    typeof starredPipelines === "object" &&
    Array.isArray(data)
  ) {
    for (const pipeline of data) {
      const pipelineKey = `${env}:${pipeline.name}`;
      pipeline.starred = !!starredPipelines[pipelineKey];
    }
  }

  return data;
};
